import ciscoLogoBlack from '@/assets/CiscoLogoBlack.svg';
import ciscoLogoWhite from '@/assets/CiscoLogoWhite.svg';

/**
 * Cisco is the parent brand of Cisco Innovation Labs (CIL) — this always
 * appears before/above the CIL mark wherever both show up, sized at least
 * as prominently. Swaps black/white variants with the app's light/dark
 * theme (unlike the CIL PNG, which is a fixed color needing a white patch
 * behind it regardless of theme).
 */
export function CiscoLogo({ className = 'h-9 w-auto' }: { className?: string }) {
  return (
    <>
      <img src={ciscoLogoBlack} alt="Cisco" className={`${className} dark:hidden`} />
      <img src={ciscoLogoWhite} alt="Cisco" className={`${className} hidden dark:block`} />
    </>
  );
}
